import { replaceSpaceAndBr } from '@/src/advocacy/utils';

import style from '../assets/environmentReportStyle';
import sanitize from '../utils/sanitize';
import { generateFooterTemplate, generateHeaderTemplate } from './headerFooter';

const removeStyle = html => {
  const res = replaceSpaceAndBr(html);
  return res.replace(/style=("|')(.*?)("|')/g, '');
};

const HTML_TEMPLATES = {
  bendData: ({ StateSnapshots, StateProvisions, LitigationBulletins, AmicusCases, Disclaimer }) => {
    return `
      <div>
        <section class="apcia-i2p7ik-white-Section">
          <div class="apcia-xcdwfm-container-lg-Container">
            <h2 class="apcia-wesxbr-2-bolder-primaryGray-Heading-LegalLandscape">State Environment Report</h2>
            <div
              class="sanitized apcia-oxnda-2-bold-2-bold-link-3-primaryGray-bold-5-6-link-stInnerContentStyle-LegalLandscape">
              ${StateSnapshots.map(
                tab => `
                <h3 class="st-content-heading__inner">${tab.FieldLabel}</h2>
                ${sanitize(removeStyle(tab.FieldValue))}
              `
              ).join('<div class="pagebreak"></div>')}
            </div>
          </div>
        </section>
        <div class="apcia-fvfub9-pagebreak"></div>
        <section class="apcia-i2p7ik-white-Section">
          <div class="apcia-xcdwfm-container-lg-Container">
            <h3 class="apcia-wesxbr-2-bolder-primaryGray-Heading-LegalLandscape">Selected State Provisions</h2>
            <div class="ant-table-wrapper apcia-1wibjg1-table">
              <div class="ant-spin-nested-loading">
                <div class="ant-spin-container">
                  <div class="ant-table ant-table-small ant-table-scroll-position-left">
                    <div class="ant-table-content">
                      <div class="ant-table-body">
                        <table class="">
                          <thead class="ant-table-thead">
                            <tr>
                              <th class=""><span class="ant-table-header-column">
                                  <div><span class="ant-table-column-title">Topic</span><span
                                      class="ant-table-column-sorter"></span></div>
                                </span></th>
                              <th class=""><span class="ant-table-header-column">
                                  <div><span class="ant-table-column-title">Details</span><span
                                      class="ant-table-column-sorter"></span></div>
                                </span></th>
                            </tr>
                          </thead>
                          <tbody class="ant-table-tbody">
                            ${StateProvisions.map(
                              (provision, i) => `
                              <tr class="ant-table-row ant-table-row-level-0" data-row-key="${i}">
                                <td class="">${provision.TopicForLitStateSnapshot}</td>
                                <td class="">
                                  <div class="sanitized ">${sanitize(
                                    provision.TopicDescription
                                  )}</div>
                                </td>
                              </tr>
                            `
                            ).join('')}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="apcia-fvfub9-pagebreak"></div>
        <section class="apcia-i2p7ik-white-Section">
          <div class="apcia-xcdwfm-container-lg-Container">
            <h3 class="apcia-wesxbr-2-bolder-primaryGray-Heading-LegalLandscape">Litigation Bulletins</h2>
            <div class="ant-list ant-list-vertical ant-list-sm ant-list-split">
              <div class="ant-spin-nested-loading">
                <div class="ant-spin-container">
                  <ul class="ant-list-items">
                    ${LitigationBulletins.map(
                      bulletin => `
                      <li class="ant-list-item ant-list-item-no-flex">
                        <div class="ant-list-item-meta apcia-1cd2yjn-meta">
                          <div class="ant-list-item-meta-content">
                            <h4 class="ant-list-item-meta-title">
                              <a href="/publications/${
                                bulletin.SitePageId
                              }" class="apcia-loigxv-link-css-CustomLink">
                                ${bulletin.PageTitle}
                              </a>
                            </h4>
                            <div class="ant-list-item-meta-description">
                              <p>${bulletin.Publications}</p>
                            </div>
                          </div>
                        </div>
                        <div>
                          ${bulletin.ExecutiveSummary}
                        <div>
                      </li>
                    `
                    ).join('')}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="apcia-fvfub9-pagebreak"></div>
        <section class="apcia-i2p7ik-white-Section">
          <div class="apcia-xcdwfm-container-lg-Container">
            <h3 class="apcia-wesxbr-2-bolder-primaryGray-Heading-LegalLandscape">Open Amicus Cases</h2>
            ${AmicusCases.map(
              amicus => `
              <div class="apcia-xt7smh-amicusCase">
                <a href="/advocacy/legal-judicial-advocacy/amicus/${amicus.LegalCaseId}"
                  class="apcia-loigxv-link-css-CustomLink">${amicus.CaseName}</a>
                <p>${amicus.IssueDescription}</p>
              </div>
            `
            ).join('')}
          </div>
        </section>
        <div class="apcia-fvfub9-pagebreak"></div>
        <section class="apcia-i2p7ik-white-Section">
          <div class="apcia-xcdwfm-container-lg-Container">
            <p><strong>${Disclaimer}</strong></p>
          </div>
        </section>
      </div>
    `;
  },
};

export function generateHTMLString(data) {
  return `
    ${generateHeaderTemplate(style)}
    ${HTML_TEMPLATES.bendData(data)}
    ${generateFooterTemplate()}
  `;
}
